import { render, staticRenderFns } from "./QuestionnaireTable.vue?vue&type=template&id=4d9d2496&"
import script from "./QuestionnaireTable.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports